import React, { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';

import { Divider } from '@mui/material';

import Affected from './Affected';
import Code from './Code';
import Description from './Description';
import HackApp from './HackApp';
import References from './References';
import Score from './Score';
import SocialReferences from './SocialReferences';
import Summary from './Summary';
import Tags from './Tags';
import Title from './Title';

const CUSTOM_TYPES = { hackapp: HackApp };

const useStyles = makeStyles({ name: 'Content' })({
    title: {
        margin: '36px 0 20px'
    },
    summary: {
        marginBottom: 16
    },
    score: {
        display: 'none',
        transition: 'all 0.2s ease-out',
        paddingBottom: 0,
        '@media (max-width: 960px)': {
            display: 'block',
            paddingBottom: 60
        }
    }
});

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
}

const Content: React.FC<Props> = ({ data }) => {
    const {
        id,
        title,
        type,
        description,
        sourceData,
        privateArea,
        cpe,
        affectedSoftware,
        affectedPackage,
        references,
        cvss2,
        cvss3,
        reporter,
        href,
        published,
        enchantments: { twitter, reddit, vulners_cpe_configuration }
    } = data;
    const { classes } = useStyles();

    const aiScore = data?.enchantments?.score;
    const epss = data?.epss;
    const posts = useMemo(() => [...(twitter?.tweets ?? []), ...(reddit?.posts ?? [])], [
        reddit?.posts,
        twitter?.tweets
    ]);

    return (
        <>
            <Summary
                id={id}
                reporter={reporter}
                href={href}
                type={type}
                published={published}
                className={classes.summary}
            />
            <Divider />
            <Title title={title || id} className={classes.title} />
            <Tags data={data} />
            <div className={classes.score}>
                <Score aiScore={aiScore} cvss2={cvss2} cvss3={cvss3} epss={epss} id={id} />
            </div>
            <Description privateArea={privateArea} description={description} />
            {CUSTOM_TYPES[type] ? React.createElement(CUSTOM_TYPES[type], { data }) : null}
            <Code sourceData={sourceData} />
            <Affected
                cpe={cpe}
                affectedPackage={affectedPackage}
                affectedSoftware={affectedSoftware}
                vulnersCpe={vulners_cpe_configuration}
            />
            <References references={references} />
            <SocialReferences posts={posts} />
        </>
    );
};

export default Content;
